import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
  RawQuery,
} from '@freelancer/datastore/core';
import { assertNever } from '@freelancer/utils';
import { FeedItemsOrderApi } from 'api-typings/feed/feed';
import { FeedItem } from './feed.model';
import { FeedCollection } from './feed.types';

export function feedBackend(): Backend<FeedCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => {
      const contextType = getQueryParamValue(query, 'contextType')[0];
      const contextId = getQueryParamValue(query, 'contextId')[0];
      if (!contextType) {
        throw new Error("Required request field 'contextType' is missing.");
      }
      if (!contextId) {
        throw new Error("Required request field 'contextId' is missing.");
      }

      return {
        endpoint: `feed/0.1/feed`,
        isGaf: false,
        params: {
          context_type: contextType,
          context_id: contextId,
          last_value: getLastValue(query, FeedItemsOrderApi.ID_DESC),
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}

/**
 * Endpoint accepts last_vale parameter
 * to use it instead of using mysql offset.
 * What's the last_value depends on ordering type.
 * This function extracts last_value from query based
 * on ordering type.
 */
function getLastValue(
  query: RawQuery<FeedItem> | undefined,
  order: FeedItemsOrderApi,
): number | undefined {
  switch (order) {
    // We have only one ordering type for now.
    // The UPDATED_DESC is not yet supported because the `updated` field is optional
    case FeedItemsOrderApi.ID_DESC:
    case FeedItemsOrderApi.UPDATED_DESC: {
      const queryId = query?.queryParams?.id
        ? query.queryParams.id[0]
        : undefined;
      return queryId?.condition === '<' ? queryId.value : undefined;
    }
    default:
      return assertNever(order);
  }
}
